// ── Pilot-only blocking selector ──
// Rendered when no contractor session exists. Lets the pilot user pick
// a seeded contractor; writes to localStorage and re-resolves identity.

import { useState } from "react";
import { useAppData } from "@/data/AppDataContext";
import { setContractorSession } from "@/data/contractor/currentContractor";
import { Button } from "@/components/ui/button";
import { HardHat } from "lucide-react";

export function ContractorIdentityGate({ onResolved }: { onResolved: () => void }) {
  const { contractors } = useAppData();
  const [selected, setSelected] = useState<string>("");

  const handleConfirm = () => {
    if (!selected) return;
    setContractorSession(selected);
    onResolved();
  };

  return (
    <div
      data-testid="contractor-identity-gate"
      className="min-h-screen flex items-center justify-center bg-background p-6"
    >
      <div className="max-w-sm w-full rounded-xl border border-border bg-card p-6 text-center">
        <div className="mx-auto mb-3 h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <HardHat className="h-6 w-6 text-primary" />
        </div>
        <h1 className="text-base font-semibold mb-1">
          No contractor session found.
        </h1>
        <p className="text-xs text-muted-foreground mb-4">
          Please select your account.
        </p>
        <select
          data-testid="contractor-identity-select"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm mb-3"
        >
          <option value="">— Choose contractor —</option>
          {contractors.map((c) => (
            <option key={c.id} value={c.id}>
              {c.companyName} ({c.id})
            </option>
          ))}
        </select>
        <Button
          data-testid="contractor-identity-confirm"
          onClick={handleConfirm}
          disabled={!selected}
          className="w-full"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
